<template>
  <div class="container">
    <h2>{{ $t('specialrequestcreatePage.title') }}</h2>
    <special-request-form
      v-if="user && stakeholder"
      :user="user"
      :stakeholder="stakeholder"
    />
  </div>
</template>

<script>
import SpecialRequestForm from "@/components/specialrequest/SpecialRequestForm.vue"

export default {
  name: 'CreateSpecialRequestView',
  components: {SpecialRequestForm},
  data() {
    return {
      user: null,
      stakeholder: null,
    }
  },
  async created() {
    this.user = this.$store.state.auth.user
    this.stakeholder = this.user.stakeholder
  },
}
</script>

<style lang="scss" scoped>
</style>
